import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "case-cluster-event" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "case-cluster-event__key" }, "ID: ", -1)
const _hoisted_3 = { class: "case-cluster-event__key" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_Features = _resolveComponent("Features")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NThumbnail, {
      actions: _ctx.thumbnailActions,
      modelValue: _ctx.item.thumbnail,
      size: "large",
      corners: "rounded",
      onAction: _cache[0] || (_cache[0] = (v) => _ctx.$emit('action', v, _ctx.item))
    }, null, 8, ["actions", "modelValue"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.item.id), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.created', 'f')) + ": ", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.formatDateTime(_ctx.item.created_date)), 1)
      ]),
      (_ctx.item.features)
        ? (_openBlock(), _createBlock(_component_Features, {
            key: 0,
            objects: "faces",
            features: _ctx.item.features,
            color: "red",
            columns: ""
          }, null, 8, ["features"]))
        : _createCommentVNode("", true)
    ])
  ]))
}